<img [src]="src" [style.maxWidth]="maxWidth" [alt]="alt" />
